<script lang="ts" setup>
import { useStaticUrl } from "@/use/common";
import { Popup } from "vant";
import { store } from "@/composable/settings/theme";
import { useI18n } from "vue-i18n";
import chatTheme from "@/composable/settings/chatTheme";

const props = defineProps<{
  show: boolean;
}>();
const emit = defineEmits<{
  (e: "update:show", value: boolean): void;
}>();

const { t } = useI18n();
const themeConfig: {
  name: string;
  value: "dark" | "light" | "auto";
  icon: string;
}[] = [
  {
    name: t("SidebarNavi.dark"),
    value: "dark",
    icon: "icon-moon-light",
  },
  {
    name: t("SidebarNavi.light"),
    value: "light",
    icon: "icon-sun-light",
  },
  {
    name: t("SidebarNavi.auto"),
    value: "auto",
    icon: "icon-dark",
  },
];
const chatConfig: {
  name: string;
  value: "colorful" | "classic";
  previewUrl: string;
}[] = [
  {
    name: t("SidebarNavi.colorful"),
    value: "colorful",
    previewUrl: `${useStaticUrl("/settings/appearance/color.png")}`,
  },
  {
    name: t("SidebarNavi.classic"),
    value: "classic",
    previewUrl: `${useStaticUrl("/settings/appearance/classic.png")}`,
  },
];
</script>
<template>
  <Popup
    :show="show"
    class="p-5 grid grid-rows-[auto_1fr] min-w-[30%] md:max-w-md w-full"
    position="center"
    round
    teleport="#main-view"
    @update:show="emit('update:show', $event)"
  >
    <div
      class="flex justify-between text-lg font-bold border-b pb-2 items-center"
    >
      <span>{{ $t("SidebarNavi.chatAppearanceSettings") }}</span>
      <i
        class="iconfont icon-xmark cursor-pointer"
        @click="emit('update:show', false)"
      />
    </div>
    <div class="flex flex-col gap-2 text-sm">
      <!-- <div class="flex flex-col gap-2 py-2">
        <div class="font-bold">{{ $t("SidebarNavi.theme") }}</div>
        <div class="flex gap-2">
          <button
            v-for="item in themeConfig"
            :key="item.value"
            :class="store === item.value ? 'bg-primary text-white' : ''"
            class="border flex-1 p-2 rounded text-center"
            @click="store = item.value"
          >
            {{ item.name }}
          </button>
        </div>
      </div> -->
      <div class="flex flex-col gap-2 py-2">
        <!-- <div class="font-bold">{{ $t("Buttons.chat") }}</div> -->
        <div class="flex gap-2 text-sm">
          <div
            v-for="item in chatConfig"
            :key="item.value"
            :class="chatTheme === item.value ? 'btn-primary' : 'btn-neutral'"
            class="btn"
            @click="chatTheme = item.value"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </Popup>
</template>
<style scoped>
.linear-background {
  background: linear-gradient(rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 20%);
}
</style>
